import { DropDown, SearchBar, NewSiteButton } from "../components/textField";
import TopNav from "../components/topnav";
import EnhancedTable from "../components/newTable";
import { useState, useEffect, useMemo } from "react";
import SiteModal from "../components/siteCreationModal";
import { content } from "../utils/data";
import {
  getSiteData,
  getStatesDropDown,
  getLocationDropDown,
  getSiteDropDown,
  createNewSite,
  editSiteSummry,
  getSiteTypeDropDown,
  getPropertyTaxApplicability,
} from "../api/serverApi";
import Edit from "../assests/edit.png";
import SurveyManagment from "../assests/s.png";
import CourtLitigation from "../assests/c.png";
import Borrowal from "../assests/b.png";
import { useNavigate } from "react-router-dom";
import { CreationForm, EditDescription } from "../components/dropdowns";
import { Button } from "@mui/material";
import Spinner from "../components/spinner";
import StatusModal from "../components/statusModal";
import { useCookies } from "react-cookie";
import { useMsal } from "@azure/msal-react";
import { getValidAccessToken } from "../services/garphService";
import * as microsoftTeams from "@microsoft/teams-js";
import { useFilterContext } from "../context/filterContext";

const SiteCreation = () => {
  const [open, setOpen] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [getState, setGetState] = useState([]);
  const [getLocation, setGetLocation] = useState([]);
  const [getSite, setGetSite] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const [selectedSiteId, setSelecteSiteId] = useState("");
  const [selectedSiteName, setSelectedSiteName] = useState("");
  const [description, setDescription] = useState("");
  const [newSummary, setNewSummary] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  const [state, setState] = useState("");
  const [location, setLocation] = useState("");
  const [site, setSite] = useState("");
  const [siteName, setSiteName] = useState("");
  const [loading, setLoading] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [filterLocations, setFilterLocations] = useState([]);
  const [filterSites, setFilterSites] = useState([]);
const [propertyTaxData, setPropertyTaxData] = useState([]);
const [selectedPropertyTax, setSelectedPropertyTax] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [selectedLocationValue, setSelectedLocationValue] = useState("");
  const { instance, accounts } = useMsal();
  const [responseMessage, setResponseMessage] = useState("");
  const [siteTypeData, setSiteTypeData] = useState([]);
  const [selectedSiteType, setSelectedSiteType] = useState("");
  const {
    filterSelectedStateId,
    setFilterSelectedStateId,
    filterSelectedLocationId,
    setFilterSelectedLocationId,
    filterSelectedSiteId,
    setFilterSelectedSiteId,
    searchText,
    setSearchText,
  } = useFilterContext();
  const [cookies, setCookie] = useCookies([
    "email",
    "firstName",
    "lastName",
    "roleName",
    "roleId",
    "accessToken",
    "fullname",
  ]);
  // Load states on mount

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value); // Captures text field input
  };

  const handleNewDescriptionChange = (event) => {
    setNewSummary(event.target.value); // Captures text field input
  };

  // site type dropdown data
  useEffect(() => {
    getSiteTypeDropDown()
      .then((res) => {
        setSiteTypeData(res.data);
      })
      .catch((err) => console.error(err));
  }, []);

  // property tax dropdown data
useEffect(() => {
  getPropertyTaxApplicability()
    .then((res) => {
      console.log("Property Tax API:", res.data);

      setPropertyTaxData(
        res.data.property_tax_applicability || []
      );
    })
    .catch((err) => console.error(err));
}, []);

  useEffect(() => {
    if (cookies.accessToken) {
      getStatesDropDown(cookies.accessToken)
        .then((response) => {
          setGetState(response.data); // Modal dropdown
          setStateList(response.data); // Filter dropdown

          setSelectedStateId("");
          setSelectedLocationId("");
          setSelecteSiteId("");
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }, [cookies.accessToken]);
  useEffect(() => {
    if (selectedStateId) {
      getLocationDropDown(
        { state_id: selectedStateId },
        cookies.accessToken,
      ).then((response) => {
        setGetLocation(response.data);
      });
    }
  }, [selectedStateId, cookies.accessToken]);


  const resetForm = () => {
    setSelectedStateId("");
    setSelectedLocationId(null);
    setSelectedLocationValue("");
    setSelectedSiteName("");
    setSelectedSiteType("");
     setSelectedPropertyTax(""); // <-- add this
    setDescription("");
    setGetLocation([]);
  };
 const handleOpen = () => {
  resetForm();
  setIsEditing(false);
  setOpen(true);
};
  const handleClose = () => {
    resetForm();
    setOpen(false);
  };
  // Utility to detect Teams context
  const isInTeams = () => {
    try {
      return window.parent !== window.self;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let token;
        if (isInTeams()) {
          // Get Teams SSO token
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          // Get MSAL token
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getSiteData(token);
        setResponseData(response.data);
      } catch (error) {
        const message =
          error.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setModalOpen(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [instance, accounts]);
  // action buttons
  const handleSurveyManagement = (siteId, siteName, state, locationName) => {
    navigate("/survey-managment", {
      state: { siteId, siteName, state, locationName },
    });
  };

  const handleCourtLitigation = (
    siteId,
    siteName,
    state,
    locationName,
    siteType,
  ) => {
    navigate("/court-litigation", {
      state: { siteId, siteName, state, locationName, siteType },
    });
  };

  const handleBuilding = (siteId, siteName, state, locationName) => {
    navigate("/building", { state: { siteId, siteName, state, locationName } });
  };

  
  const rowsWithActions = useMemo(() => {
    return (responseData?.sites || []).map(
      ({
        site_id,
        location_id,
        state_id,
        name,
        state,
        location_name,
        description,
        site_type,
        document_categories = [],
        ...rest
      }) => {
        const categoryNames = document_categories.map((item) => item.name);

        const hasLand = categoryNames.includes("Land Documents");
        const hasPrePost = categoryNames.includes("Pre & Post Construction");
        const hasCourt =
          categoryNames.includes("Court Litigation") ||
          categoryNames.includes("Litigation");
        const isAdmin = cookies.permissions === "Admin";

        return {
          key: site_id,
          name,
          site_id,
          state_id,
          location_id,
          state,
          location_name,
          description,
          site_type,
          document_categories,
          ...rest,

          actions: (
            <div className="flex items-center gap-2 min-w-[120px]">
              {/* Edit - Always Show */}

              <img
                src={Edit}
                alt="Edit"
                style={{
                  width: "20px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                onClick={() => handleEdit(site_id)}
              />

              {/* S - Land Documents */}
              {hasLand && (
                <img
                  src={SurveyManagment}
                  alt="Survey"
                  title="Survey Management"
                  style={{
                    width: "20px",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                  onClick={() =>
                    handleSurveyManagement(site_id, name, state, location_name)
                  }
                />
              )}

              {/* B - Pre & Post Construction */}
              {hasPrePost && (
                <img
                  src={Borrowal}
                  alt="Building"
                  title="Pre & Post Construction"
                  style={{
                    width: "20px",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                  onClick={() =>
                    handleBuilding(site_id, name, state, location_name)
                  }
                />
              )}

              {/* C - Court Litigation */}
              {hasCourt && (
                <img
                  src={CourtLitigation}
                  alt="Litigation"
                  title="Court Case"
                  style={{
                    width: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    handleCourtLitigation(
                      site_id,
                      name,
                      state,
                      location_name,
                      site_type,
                    )
                  }
                />
              )}
            </div>
          ),
        };
      },
    );
  }, [responseData]);

  const filteredRows = useMemo(() => {
    return rowsWithActions.filter((row) => {
      const matchState = filterSelectedStateId
        ? row.state_id === filterSelectedStateId
        : true;
      const matchLocation = filterSelectedLocationId
        ? row.location_id === filterSelectedLocationId
        : true;
      const matchSite = filterSelectedSiteId
        ? row.key === filterSelectedSiteId
        : true;

      const normalizedSearch = searchText
        .trim()
        .replace(/\s+/g, " ")
        .toLowerCase();

      const searchContent = [
        row.name,
        row.state,
        row.location_name,
        row.description,
        row.site_type,
        row.property_tax_applicability,
      ]
        .join(" ")
        .replace(/\s+/g, " ")
        .toLowerCase();

      const matchSearch = normalizedSearch
        ? searchContent.includes(normalizedSearch)
        : true;

      return matchState && matchLocation && matchSite && matchSearch;
    });
  }, [
    rowsWithActions,
    filterSelectedStateId,
    filterSelectedLocationId,
    filterSelectedSiteId,
    searchText,
  ]);

  const onChangeSite = (event) => {
    setSelectedSiteName(event.target.value); // Captures text field input
  };

  // site type change handler
  const onChangeSiteType = (e) => {
    setSelectedSiteType(e.target.value);
  };
  // propertty tax change handler
  const onChangePropertyTax = (e) => {
  setSelectedPropertyTax(e.target.value);
};
  // post site creation data to server
  const handleSubmit = async () => {
    setLoading(true);
    let location_id = selectedLocationId;

    if (!location_id && selectedLocationValue) {
      const match = getLocation.find(
        (loc) => loc.name.toLowerCase() === selectedLocationValue.toLowerCase(),
      );
      location_id = match ? match.location_id : selectedLocationValue;
    }

    if (
      !selectedStateId ||
      !location_id ||
      !selectedSiteName ||
      !selectedSiteType||
  !selectedPropertyTax
    ) {
      setResponseMessage(
        "Please fill in all required fields: State, Location, Site Name and Site Type.",
      );
      resetForm();
      setIsSuccess(false);
      setOpen(false);
      setModalOpen(true);
      setLoading(false);
      return;
    }
    const selectedType = siteTypeData.find(
      (item) => item.site_type_id === selectedSiteType,
    );
const selectedTax = propertyTaxData.find(
  (item) =>
    item.property_tax_applicability_id === selectedPropertyTax
);
    // post data ig
    const data = {
      state_id: selectedStateId,
      location_id: location_id,
      name: selectedSiteName,
      site_type: selectedType?.name,
        property_tax_applicability_id: selectedPropertyTax,
      description: description,
    };console.log("Payload:", data);

    try {
      let token;
      if (isInTeams()) {
        // Get Teams SSO token
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        // Get MSAL token
        token = await getValidAccessToken(instance, accounts);
      }

      const response = await createNewSite(data, token);

      const siteId = response.data?.site_id;

      if (siteId) {
        setResponseMessage(
          response.data?.message || "Site created successfully",
        );
        setIsSuccess(true); // ✅ green modal

        // ✅ Re-fetch updated site list with fresh token
        const siteResponse = await getSiteData(token);
        setResponseData(siteResponse.data);
      } else {
        setResponseMessage("Invalid server response");
        setIsSuccess(false); // ❌ red modal
      }

      setModalOpen(true);
      setOpen(false);
      setLoading(false);
    } catch (error) {
      const message =
        error.response?.data?.detail || "An unexpected error occurred";
      console.error("Error creating site:", error);

      setResponseMessage(message);
      setIsSuccess(false); // ❌ red modal
      resetForm();
      setModalOpen(true);
      setOpen(false);
      setLoading(false);
    }
  };
  // edit method
  const handleEdit = (siteId) => {
    const site = responseData?.sites?.find((site) => site.site_id === siteId);

    if (site) {
      setState(site.state || "");
      setLocation(site.location_name || "");
      setSite(site.site_id || "");
      setSiteName(site.name || "");
      setSelectedSiteType(site.site_type || ""); // ✅ ADD site type to state
      setSelectedPropertyTax(site.property_tax_applicability_id || "");
      setNewSummary(site.description || "");
      setIsEditing(true);
      setOpen(true);
    } else {
      console.error("Site not found with ID:", siteId);
    }
  };

  const handleNewDescription = async () => {
    setLoading(true);

    const data = { description: newSummary ,  property_tax_applicability_id: selectedPropertyTax,};

    try {
      let token;
      if (isInTeams()) {
        // Get Teams SSO token
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        // Get MSAL token
        token = await getValidAccessToken(instance, accounts);
      }

      const response = await editSiteSummry(site, data, token);

      const message = response.data?.message;
      const siteIdFromResponse = response.data?.site_id;

      if (message && siteIdFromResponse) {
        setResponseData((prev) => {
          const updatedSites = prev.sites.map((s) =>
            s.site_id === siteIdFromResponse
              ? { ...s, description: newSummary }
              : s,
          );
          return { ...prev, sites: updatedSites };
        });

        setResponseMessage(message || "Site summary updated successfully");
        setIsSuccess(true); // ✅ green modal
      } else {
        setResponseMessage("Invalid server response");
        setIsSuccess(false); // ❌ red modal
      }

      setModalOpen(true);
      setOpen(false);
      setLoading(false);
    } catch (err) {
      const message =
        err.response?.data?.detail || "An unexpected error occurred";
      console.error("Error updating site summary:", err);

      setResponseMessage(message);
      setIsSuccess(false); // ❌ red modal
      setModalOpen(true);
      setOpen(false);
      setLoading(false);
    }
  };

  // If you have location_id, find the matching name for controlled autocomplete input
  const locationInputValue =
    selectedLocationId && getLocation.length
      ? getLocation.find((loc) => loc.location_id === selectedLocationId)
          ?.name || ""
      : selectedLocationValue;

  const onChangeLocation = (input) => {
    if (typeof input === "string") {
      setSelectedLocationId(null);
      setSelectedLocationValue(input);
    } else if (input && input.location_id) {
      setSelectedLocationId(input.location_id);
      setSelectedLocationValue(input.name);
    } else {
      setSelectedLocationId(null);
      setSelectedLocationValue("");
    }
  };
  // When filterSelectedStateId changes (and it's from context), fetch locations
  useEffect(() => {
    if (filterSelectedStateId) {
      getLocationDropDown(
        { state_id: filterSelectedStateId },
        cookies.accessToken,
      ).then((res) => {
        setFilterLocations(res.data);
      });
    }
  }, [filterSelectedStateId, cookies.accessToken]);

  // When filterSelectedLocationId changes, fetch sites
  useEffect(() => {
    if (filterSelectedLocationId) {
      getSiteDropDown(
        { location_id: filterSelectedLocationId },
        cookies.accessToken,
      ).then((res) => {
        setFilterSites(res.data);
      });
    } else {
      setFilterSites([]);
    }
  }, [filterSelectedLocationId, cookies.accessToken]);

  return (
    <>
      <div>
        <TopNav />
      </div>
      <div className="px-4 md:px-[35px] py-2 font-bold text-xl md:text-2xl">
        Site Creation
      </div>
      <div className="flex flex-wrap px-4 md:px-[35px] gap-2 md:gap-x-3 items-center">
        <div className="w-full sm:w-auto flex-shrink-0">
          <SearchBar
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="State"
            placeholder="None"
            responseData={stateList}
            labelKey="name"
            valueKey="state_id"
            value={filterSelectedStateId}
            onChange={(e) => {
              const selectedState = e.target.value;
              setFilterSelectedStateId(selectedState);

              getLocationDropDown(
                { state_id: selectedState },
                cookies.accessToken,
              ).then((res) => {
                setFilterLocations(res.data);
                setFilterSelectedLocationId(null);
                setFilterSites([]);
              });
            }}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="Location"
            placeholder="None"
            responseData={filterLocations}
            labelKey="name"
            valueKey="location_id"
            value={filterSelectedLocationId}
            onChange={(e) => {
              const selectedLocation = e.target.value;
              setFilterSelectedLocationId(selectedLocation);
              // Fetch sites based on selected location
              getSiteDropDown(
                { location_id: selectedLocation },
                cookies.accessToken,
              ).then((res) => {
                setFilterSites(res.data);
                setFilterSelectedSiteId(null);
              });
            }}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="Site"
            placeholder="None"
            responseData={filterSites}
            labelKey="name"
            valueKey="site_id"
            value={filterSelectedSiteId}
            onChange={(e) => {
              setFilterSelectedSiteId(e.target.value);
            }}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <Button
            variant="contained"
            onClick={() => {
              setFilterSelectedStateId("");
              setFilterSelectedLocationId("");
              setFilterSelectedSiteId("");
              setFilterLocations([]);
              setFilterSites([]);
              setSearchText("");
            }}
            sx={{
              backgroundColor: "#1381B5",
              "&:hover": { backgroundColor: "#0f6c99" },
              width: "95px",
              height: "40px",
              fontSize: "10px",
              whiteSpace: "nowrap", // prevents text wrapping
            }}
          >
            Clear All
          </Button>
        </div>
        {cookies.permissions === "Admin" && (
          <div className="w-full sm:w-auto py-2 sm:ml-auto flex-shrink-0">
            <NewSiteButton Name="Add Site" handleOpen={handleOpen} />
          </div>
        )}
      </div>
      <SiteModal
        title={isEditing ? "Edit Site" : "Site Creation"} // Change title based on editing
        open={open}
        handleClose={handleClose}
        handleSubmit={isEditing ? handleNewDescription : handleSubmit}
        formContent={
          isEditing ? (
            <EditDescription
              siteType={selectedSiteType} // ✅ ADD site type to props
              site={site}
              siteName={siteName}
              state={state}
              location={location}
              description={newSummary}
              onChange={handleNewDescriptionChange}
              isEditing={isEditing}
              propertyTaxData={propertyTaxData}
  selectedPropertyTax={selectedPropertyTax}
  onChangePropertyTax={onChangePropertyTax}
    isAdmin={cookies.permissions === "Admin"}   // <-- pass this

            />
          ) : (
            <CreationForm
              responseData={getState}
              responseDataLocation={getLocation}
              responseSiteType={siteTypeData}
               propertyTaxData={propertyTaxData}
  selectedPropertyTax={selectedPropertyTax}
  onChangePropertyTax={onChangePropertyTax}
              nameLocation="name"
              nameState="name"
              stateId="state_id"
              locationId="location_id"
              onChangeState={(e) => setSelectedStateId(e.target.value)}
              onChangeLocation={onChangeLocation}
              onChangeSite={onChangeSite}
              onChangeSiteType={onChangeSiteType} // ✅ make sure added
              selectedSiteType={selectedSiteType}
              selectedStateId={selectedStateId}
              selectedLocationValue={locationInputValue}
              onChange={handleDescriptionChange}
              description={description}
            />
          )
        }
      />
      <div className="py-2 px-[35px]">
        <EnhancedTable rows={filteredRows} header={content.columnSite} />
      </div>
      {loading && <Spinner />}
      <StatusModal
        isOpen={isModalOpen}
        onClose={() => {
          setModalOpen(false);

          if (isSuccess) {
            window.location.reload();
          }
        }}
        message={responseMessage}
        isSuccess={isSuccess}
      />
    </>
  );
};

export default SiteCreation;
